"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var CLASS_NAME = 'ontodia-toolbar';
var DefaultToolbar = /** @class */ (function (_super) {
    tslib_1.__extends(DefaultToolbar, _super);
    function DefaultToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeLanguage = function (event) {
            var value = event.currentTarget.value;
            _this.props.onChangeLanguage(value);
        };
        _this.onExportSVG = function () {
            _this.props.onExportSVG();
        };
        _this.onExportPNG = function () {
            _this.props.onExportPNG();
        };
        return _this;
    }
    DefaultToolbar.prototype.renderSaveDiagramButton = function () {
        if (!this.props.onSaveDiagram) {
            return null;
        }
        return (React.createElement("button", { type: 'button', className: 'saveDiagramButton ontodia-btn ontodia-btn-primary', disabled: this.props.canSaveDiagram === false, onClick: this.props.onSaveDiagram },
            React.createElement("span", { className: 'fa fa-floppy-o', "aria-hidden": 'true' }),
            " Save diagram"));
    };
    DefaultToolbar.prototype.renderPersistAuthoredChangesButton = function () {
        if (!this.props.onPersistChanges) {
            return null;
        }
        return (React.createElement("button", { type: 'button', className: 'saveDiagramButton ontodia-btn ontodia-btn-success', disabled: this.props.canPersistChanges === false, onClick: this.props.onPersistChanges },
            React.createElement("span", { className: 'fa fa-floppy-o', "aria-hidden": 'true' }),
            " Save data"));
    };
    DefaultToolbar.prototype.renderHelpButton = function () {
        if (this.props.hidePanels) {
            return null;
        }
        return (React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', onClick: this.props.onShowTutorial },
            React.createElement("span", { className: 'fa fa-info-circle', "aria-hidden": 'true' }),
            " Help"));
    };
    DefaultToolbar.prototype.renderLanguages = function () {
        var _a = this.props, selectedLanguage = _a.selectedLanguage, languages = _a.languages;
        if (languages.length <= 1) {
            return null;
        }
        return (React.createElement("span", { className: "ontodia-btn-group " + CLASS_NAME + "__language-selector" },
            React.createElement("label", { className: 'ontodia-label' },
                React.createElement("span", null, "Data Language - ")),
            React.createElement("select", { value: selectedLanguage, onChange: this.onChangeLanguage }, languages.map(function (_a) {
                var code = _a.code, label = _a.label;
                return React.createElement("option", { key: code, value: code }, label);
            }))));
    };
    DefaultToolbar.prototype.renderButtonsTogglePanels = function () {
        var _a = this.props, hidePanels = _a.hidePanels, isLeftPanelOpen = _a.isLeftPanelOpen, onLeftPanelToggle = _a.onLeftPanelToggle, isRightPanelOpen = _a.isRightPanelOpen, onRightPanelToggle = _a.onRightPanelToggle;
        if (hidePanels) {
            return null;
        }
        var className = "ontodia-btn ontodia-btn-default " + CLASS_NAME + "__toggle";
        return (React.createElement("div", { className: 'ontodia-btn-group ontodia-btn-group-sm' },
            React.createElement("button", { type: 'button', className: className + " " + CLASS_NAME + "__toggle-left " + (isLeftPanelOpen ? 'active' : ''), onClick: onLeftPanelToggle, title: 'Classes Panel' }),
            React.createElement("button", { type: 'button', className: className + " " + CLASS_NAME + "__toggle-right " + (isRightPanelOpen ? 'active' : ''), onClick: onRightPanelToggle, title: 'Connections Panel' })));
    };
    DefaultToolbar.prototype.render = function () {
        var intro = '<h4>Toolbox</h4>' +
            '<p>You can use additional tools for working with your diagram, such as choosing between automatic ' +
            'layouts or fit diagram to screen, etc.</p>' +
            '<p>Don’t forget to save diagrams, it always comes handy after all.</p>';
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: 'ontodia-btn-group ontodia-btn-group-sm', "data-position": 'bottom', "data-step": '6', "data-intro": intro },
                this.renderSaveDiagramButton(),
                this.renderPersistAuthoredChangesButton(),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Force layout', onClick: this.props.onForceLayout },
                    React.createElement("span", { className: 'fa fa-sitemap', "aria-hidden": 'true' }),
                    " Layout"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Zoom In', onClick: this.props.onZoomIn },
                    React.createElement("span", { className: 'fa fa-search-plus', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Zoom Out', onClick: this.props.onZoomOut },
                    React.createElement("span", { className: 'fa fa-search-minus', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Fit to Screen', onClick: this.props.onZoomToFit },
                    React.createElement("span", { className: 'fa fa-arrows-alt', "aria-hidden": 'true' })),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Export diagram as PNG', onClick: this.onExportPNG },
                    React.createElement("span", { className: 'fa fa-picture-o', "aria-hidden": 'true' }),
                    " PNG"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Export diagram as SVG', onClick: this.onExportSVG },
                    React.createElement("span", { className: 'fa fa-picture-o', "aria-hidden": 'true' }),
                    " SVG"),
                React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Print diagram', onClick: this.props.onPrint },
                    React.createElement("span", { className: 'fa fa-print', "aria-hidden": 'true' })),
                this.renderLanguages(),
                this.renderHelpButton()),
            this.renderButtonsTogglePanels()));
    };
    return DefaultToolbar;
}(React.Component));
exports.DefaultToolbar = DefaultToolbar;
